<script setup>
import { Banner } from '@dashhudson/dashing-ui/banner';
import { computed } from 'vue';

import MessageBanner from '@/components/MessageBanner.vue';
import { useCustomerJourneyStore } from '@/stores/customer-journey';
import { PLATFORM_CONNECTION_REQUIRED, usePlatformStore } from '@/stores/platform';

const { platformType } = defineProps({
  platformType: { type: String, required: true },
  dashingUi: { type: Boolean, default: false }, // should eventually be the only option
});

const platformStore = usePlatformStore();
const customerJourneyStore = useCustomerJourneyStore();
const showBanner = computed(() => {
  const platformsToCheck = platformType === 'all' ? PLATFORM_CONNECTION_REQUIRED : [platformType];
  return platformsToCheck.some((type) =>
    platformStore.isNewPlatformConnection({ platformType: type }),
  );
});

const importingMessage = computed(() => {
  const message = "We're importing your historical data.";
  if (customerJourneyStore.hasPlanGrow) {
    return `${message} We'll notify you when the process is complete.`;
  }
  return message;
});
</script>

<template>
  <Banner
    v-if="dashingUi && showBanner"
    :message="importingMessage"
    :closable="false"
    severity="info"
  />
  <MessageBanner v-else-if="showBanner" :text="importingMessage" type="neutral" class="!mt-6" />
</template>
